<template>
    <div class="headercontent">
        <div
            v-if="showHeaderArrow"
            class="headerarror"
        >
            <returnarror
                width="26"
                height="26"
                @click="returclick"
            ></returnarror>
        </div>
        <div class="mainflex">
            <div
                v-if="!showHeaderArrow"
                class="headerarror"
            >
                <!-- v-if="userinfo.role === '1'" -->
                <el-button
                    @click="setrole"
                    style="padding: 5px"
                    v-if="userinfo.role === 1"
                >
                    Permissions
                </el-button>
            </div>

            <!-- <div
                v-if="showchange"
                :class="['challenge-btn', userinfo.role === 1 && !showHeaderArrow ? 'margindiv' : '']"
                @click="returchange"
            >
                View Challenges
            </div> -->
        </div>
        <div class="kpiTitle">
            <!-- 插槽，用于传入动态标题内容 -->

            <slot name="title"></slot>
        </div>
        <div
            v-if="showChoice"
            class="choice"
        >
            <!-- <div style="margin-right: 20px">
                Name: <span style="font-weight: 600">{{ userinfo.username }}</span>
            </div> -->
            <span>Organization：</span>
            <el-tree-select
                value-key="id"
                v-model="selectvalue"
                :data="data"
                :props="defaultProps"
                :render-after-expand="false"
                show-checkbox
                check-strictly
                style="width: 220px"
                @change="selectchange"
            />
            <slot name="extra"></slot>
        </div>
        <!-- check-strictly -->
        <el-dialog
            v-model="dialogVisible"
            width="500"
            :before-close="handleClose"
        >
            <div class="dialog-toolbar">
                <el-input
                    v-model="input1"
                    class="search-input"
                    size="large"
                    placeholder="Search"
                    @input="inputchang"
                    :suffix-icon="Search"
                />
                <el-button
                    v-if="userinfo.role === 1"
                    type="primary"
                    @click="goToSurnameManage"
                    class="surname-manage-btn"
                >
                    姓氏管理
                </el-button>
            </div>
            <div style="height: 500px; overflow: hidden; overflow-y: scroll">
                <div
                    v-for="(item, index) in userlist"
                    :key="index"
                    class="userlist"
                >
                    <div class="userlisrtitle">
                        <span>
                            <span class="itemusername">{{ item.nickname }}</span>
                            <span
                                class="isCoach"
                                v-if="item.role !== 3"
                            >
                                {{ item.role === 3 ? "" : "Coodinator" }}
                            </span>
                        </span>
                        <span></span>
                    </div>
                    <div>
                        <span
                            v-if="item.role === 3"
                            class="smallbtncoach"
                            @click="setCoach(item, item.id, 2)"
                        >
                            Set as Coodinator
                        </span>
                        <span
                            v-if="item.role === 2"
                            class="smallbtncoach cancelcoach"
                            @click="setCoach(item, item.id, 3)"
                        >
                            Cancel Coodinator
                        </span>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
                    <el-button
                        type="primary"
                        @click="dialogVisible = false"
                    >
                        Close
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import returnarror from "@/components/icon/returnarror.vue";
import { ElTreeSelect } from "element-plus";
import { ref, defineProps, defineEmits } from "vue";
import { ElMessage, ElButton, ElDialog, ElInput } from "element-plus";
import { getdeparmentlist, joinlistAPI, getuserlistAPI, grantAPI } from "@/api/api";
import { Search } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";
const dialogVisible = ref(false);
const userinfo = ref();
userinfo.value = JSON.parse(localStorage.getItem("userinfo"));
const Router = useRouter();
const Route = useRoute();
const myRole = ref(localStorage.getItem("role"));
const setrole = () => {
    dialogVisible.value = true;
};
const userlist = ref([]);
const copyuserlist = ref([]);

const getuserlist = () => {
    getuserlistAPI().then((res) => {
        userlist.value = res.data;
        copyuserlist.value = res.data;
    });
};
if (userinfo.value.role === 1) {
    getuserlist();
}
// 定义 props 以控制是否显示 `headerarror` 和 `choice`
const props = defineProps({
    showHeaderArrow: {
        type: Boolean,
        default: true
    },
    showChoice: {
        type: Boolean,
        default: true
    },
    showchange: {
        type: Boolean,
        default: true
    }
});
const emit = defineEmits(["changeorg"]);
const selectvalue = ref("");
const data = ref([]);
const input1 = ref();
const inputchang = (v) => {
    userlist.value = copyuserlist.value.filter((item) =>
        item.nickname.toUpperCase().includes(v.toUpperCase())
    );
};
const getlist = () => {
    getdeparmentlist().then((res) => {
        if (res.code === "8200") {
            data.value = res.data;

            selectvalue.value = userinfo.value.deptId || "";
        }
    });
};

getlist();
const setCoach = (item, userId, roleId) => {
    const formda = new FormData();
    formda.append("userId", userId);
    formda.append("role", roleId);
    // const data = {
    //     userId: userId,
    //     role: roleId
    // };
    grantAPI(formda).then((res) => {
        if (res.code == "8200") {
            ElMessage({
                type: "success",
                message: "success"
            });
            item.role = res.data;
        } else {
            ElMessage({
                type: "error",
                message: res.message
            });
        }
    });
    // .catch(() => {
    //     ElMessage({
    //         type: "error",
    //         message: "error"
    //     });
    // });
};
const defaultProps = {
    children: "children",
    label: "name",
    value: "id"
};

const selectchange = (v) => {
    const formData = new FormData();
    formData.append("id", selectvalue.value ? selectvalue.value : 0);
    joinlistAPI(formData).then((res) => {
        if (res.code === "8200") {
            const currentUserInfo = JSON.parse(localStorage.getItem("userinfo"));
            currentUserInfo.deptId = selectvalue.value;
            localStorage.setItem("userinfo", JSON.stringify(currentUserInfo));
            emit("changeorg");
            ElMessage({
                type: "success",
                message: "success"
            });
        }
    });
};
console.log(Route.path, "Route.path");

const returclick = () => {
    myRole.value = localStorage.getItem("role");
    const m = Route.query.month;
    const md = Route.query.monthDate;
    const onDetail = Route.path === "/detail" || Route.name === "detail";
    const onAll = Route.path === "/all" || Route.name === "all";
    const typeOk = Route.query.type === "1" || Route.query.type === 1;
    const fromAll = Route.query.from;
    if (myRole.value === "1" && onDetail && typeOk) {
        let query = {};
        if (m != null && m !== "") {
            query.month = m;
        }
        if (md != null && md !== "") {
            query.monthDate = md;
        }
        // 保留来源类型，返回时能区分是"成员KPI"还是"全部KPI"
        if (fromAll) {
            query.type = fromAll;
        }
        Router.push({ path: "/all", query });
        return;
    }
    if (onAll) {
        Router.push({ path: "/", query: { month: m } });
        return;
    }
    Router.back();
};
const returchange = () => {
    Router.push("change");
};
const goToSurnameManage = () => {
    Router.push("/surname-manage");
};
</script>

<style lang="scss" scoped>
.kpiTitle {
    width: 100%;
    min-width: 300px;
    text-align: center;
    font-weight: 800;
    font-size: 20px;
}
.headercontent {
    display: flex;
    justify-content: canter;
    cursor: pointer;
    position: relative;
    margin-bottom: 10px;
    position: relative;
}
.headerarror {
    position: absolute;
    left: 10px;
    top: 10px;
}
.mainflex {
    position: absolute;
    left: 20px;
}
.choice {
    position: absolute;
    right: 10px;
    display: flex;
    top: 10px;
    cursor: pointer;
    align-items: center;
}
.userlist {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    padding: 20px 10px;
}
.userlist:hover {
    background-color: #eeeeee;
}
.smallbtncoach {
    cursor: pointer;
    padding: 5px;
    border-radius: 10px;
    background-color: #409eff;
    color: #fff;
}
.cancelcoach {
    background-color: #ccc;
    color: #fff;
}
.itemusername {
    font-size: 16px;
    font-weight: 600;
}
.isCoach {
    font-size: 10px;
    border-radius: 10px;
    border: 1px solid #56a7fd;
    color: #56a7fd;
    padding: 5px;
    margin-left: 5px;
}
.challenge-btn {
    /* 基础样式 */
    width: 125px;
    padding: 8px 0px;

    background-color: #4caf50; /* 绿色背景 */
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    text-align: center;
    transition: all 0.3s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
    /* 可选：添加文字禁止选择 */
    user-select: none;
    -webkit-user-select: none;
}
.margindiv {
    margin-left: 100px;
}
/* 悬停效果 */
.challenge-btn:hover {
    background-color: #45a049;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* 点击效果 */
.challenge-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.dialog-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebeef5;
}

.search-input {
    flex: 1;
    max-width: 300px;
}

.surname-manage-btn {
    white-space: nowrap;
    transition: all 0.3s ease;
}

.surname-manage-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}
</style>
